import { render, staticRenderFns } from "./ResponseNotification.vue?vue&type=template&id=9f9f93b6"
import script from "./ResponseNotification.vue?vue&type=script&lang=js"
export * from "./ResponseNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports